import { createGlobalStyle } from 'styled-components';
import SplitHome from './components/SplitHome';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #0d0820;
    font-family: 'Inter', sans-serif;
  }

  #root {
    width: 100%;
    height: 100%;
  }

  /* No mobile as metades empilham e podem passar da tela: liberar rolagem */
  @media (max-width: 820px) {
    html, body {
      height: auto;
      overflow-x: hidden;
      overflow-y: auto;
    }
    #root { height: auto; }
  }

  ::selection {
    background: #c9973a;
    color: #0d0820;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <SplitHome />
    </>
  );
}

export default App;
